import moment from 'moment';
// @ts-expect-error
import {createReducer} from 'redux-act';
import {REHYDRATE} from 'redux-persist';

import {getRehydratedValueForDateProperty} from 'nutshell-core/reducer-utils';

// @ts-expect-error
import * as actions from '../../dashboard-actions';

type ActivitiesState = {
    items: {
        [id: string]: ActivityState;
    };
    totalOverdueCount: number;
};

const defaultActivitiesState = {
    items: {},
    totalOverdueCount: 0,
} as const;

type ActivitiesConfigState = {
    filter: string;
    previousUrl?: string;
    nextUrl?: string;
    displayDate: number; // UNIX milliseconds,
    scrolledToDate: number; // UNIX milliseconds,
    lastUpdated: number | null | undefined; // UNIX milliseconds
    overdueSortDirection: 'asc' | 'desc';
};

const defaultActivitiesConfigState = {
    filter: '',
    previousUrl: undefined,
    nextUrl: undefined,
    displayDate: moment().startOf('day').valueOf(),
    scrolledToDate: moment().startOf('day').valueOf(),
    lastUpdated: null,
    overdueSortDirection: 'desc',
} as const;

type User = any; // TODO (@ianvs 2017-06-26): give this an actual definition

type ActivityState = {
    id: string;
    type?: 'activities';
    name?: string;
    errorMessage?: string;
    startTime: number | null | undefined; // UNIX seconds,
    participants: User[];
    lastUpdated: number | null | undefined; // UNIX milliseconds,
    didInvalidate: boolean;
};

const defaultActivityState = {
    id: undefined,
    type: undefined,
    name: undefined,
    errorMessage: undefined,
    startTime: null,
    participants: [],
    lastUpdated: 0,
    didInvalidate: false,
} as const;

export const activityReducer: (arg1: ActivityState, arg2: any) => ActivityState = createReducer(
    {
        // @ts-expect-error
        [actions.updateActivityData]: (state, payload) => {
            return {
                ...state,
                errorMessage: undefined,
                lastUpdated: new Date().getTime(),
                didInvalidate: false,
                ...payload,
            };
        },
    },
    defaultActivityState
);

export const sidebarActivitiesConfigReducer: (
    arg1: ActivitiesConfigState,
    arg2: any
) => ActivitiesConfigState = createReducer(
    {
        // @ts-expect-error
        [actions.updateActivityFilter]: (state, payload) => {
            return {
                ...state,
                nextUrl: undefined,
                previousUrl: undefined,
                scrolledToDate: state.displayDate,
                filter: payload,
            };
        },
        // @ts-expect-error
        [actions.updateActivityDisplayDate]: (state, payload) => {
            return {
                ...state,
                nextUrl: undefined,
                previousUrl: undefined,
                displayDate: payload.getTime(),
                scrolledToDate: payload.getTime(),
                lastUpdated: moment().valueOf(),
            };
        },
        // @ts-expect-error
        [actions.updateActivityListScrolledToDate]: (state, scrolledToDate) => {
            return {
                ...state,
                scrolledToDate: scrolledToDate,
            };
        },
        // @ts-expect-error
        [actions.updateActivitiesForDay]: (state, {meta}) => {
            return {...state, nextUrl: meta.next, previousUrl: meta.prev};
        },
        // @ts-expect-error
        [actions.updateOverdueSortDirection]: (state, payload) => {
            return {
                ...state,
                overdueSortDirection: payload,
            };
        },
        // @ts-expect-error
        [REHYDRATE]: (state, persistedState) => {
            if (
                !persistedState ||
                !persistedState.dashboard ||
                !persistedState.dashboard.activitiesConfig
            ) {
                return state;
            }

            return {
                ...state,
                ...persistedState.dashboard.activitiesConfig,
                displayDate: getRehydratedValueForDateProperty(
                    persistedState.dashboard.activitiesConfig,
                    'displayDate'
                ),
                scrolledToDate: getRehydratedValueForDateProperty(
                    persistedState.dashboard.activitiesConfig,
                    'scrolledToDate'
                ),
                overdueSortDirection:
                    persistedState.dashboard.activitiesConfig.overdueSortDirection || 'desc',
            };
        },
    },
    defaultActivitiesConfigState
);

export const activitiesReducer: (arg1: ActivitiesState, arg2: any) => ActivitiesState =
    createReducer(
        {
            // @ts-expect-error
            [actions.updateActivitiesForDay]: (state, {activities}) => {
                const newActivities = activities.reduce(
                    // @ts-expect-error
                    (newState, current) => {
                        newState[current.id] = activityReducer(
                            state.items[current.id],
                            actions.updateActivityData(current)
                        );

                        return newState;
                    },
                    {...state.items}
                );

                return {...state, items: newActivities};
            },
            // @ts-expect-error
            [actions.updateActivitiesForMonth]: (state, activities) => {
                const newActivities = activities.reduce(
                    // @ts-expect-error
                    (newState, current) => {
                        newState[current.id] = activityReducer(
                            state.items[current.id],
                            actions.updateActivityData(current)
                        );

                        return newState;
                    },
                    {...state.items}
                );

                return {...state, items: newActivities};
            },
            // @ts-expect-error
            [actions.updateActivityTotalOverdueCount]: (state, totalOverdueCount) => {
                return {...state, totalOverdueCount: totalOverdueCount};
            },
            // @ts-expect-error
            [actions.updateOverdueActivities]: (state, activities) => {
                const newActivities = activities.reduce(
                    // @ts-expect-error
                    (newState, current) => {
                        newState[current.id] = activityReducer(
                            state.items[current.id],
                            actions.updateActivityData(current)
                        );

                        return newState;
                    },
                    {...state.items}
                );

                return {...state, items: newActivities};
            },
            // @ts-expect-error
            [actions.updateActivityDataById]: (state, payload) => {
                const newActivities = {
                    ...state.items,
                    [payload.id]: activityReducer(
                        state.items[payload.id],
                        actions.updateActivityData(payload)
                    ),
                } as const;

                return {...state, items: newActivities};
            },
            // @ts-expect-error
            [actions.updateActivityFilter]: (state) => {
                return {...state, items: {}};
            },
            // @ts-expect-error
            [REHYDRATE]: (state, persistedState) => {
                if (
                    !persistedState ||
                    !persistedState.dashboard ||
                    !persistedState.dashboard.activities
                )
                    return state;

                return {
                    ...state,
                    ...persistedState.dashboard.activities,
                    items: {},
                };
            },
        },
        defaultActivitiesState
    );
